import React, { FC } from 'react';

export enum IconSize {
    XSmall = 'xsmall',
    Small = 'small',
    Medium = 'medium',
    Large = 'large',
    XLarge = 'xlarge',
}

export interface IconProps {
    component?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
    size?: IconSize | number;
    width?: number;
    height?: number;
    color?: string;
    className?: string;
    style?: React.CSSProperties;
}

const Icon: FC<IconProps> = ({
    component: Component,
    size,
    className,
    color,
    style,
    width,
    height,
    ...props
}) => {
    if (!Component) return null;

    return (
        <span
            className={`s9sicon ${className}`}
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                fontStyle: 'normal',
                lineHeight: '1em',
                textAlign: 'center',
                textTransform: 'none',
                verticalAlign: '-0.125em',
                textRendering: 'optimizeLegibility',
                WebkitFontSmoothing: 'antialiased',
                ...(color ? { color } : {}),
                ...style,
            }}
            {...props}
        >
            <Component
                width={
                    width
                        ? width
                        : size
                        ? `${getIconSizePx(size)}px`
                        : height
                        ? undefined
                        : '1.1em'
                }
                height={
                    height
                        ? height
                        : size
                        ? `${getIconSizePx(size)}px`
                        : width
                        ? undefined
                        : '1.1em'
                }
                fill="none"
                viewBox={`0 0 24 24`}
                {...(color ? { stroke: color } : {})}
            />
        </span>
    );
};

export default Icon;

function getIconSizePx(size: IconSize | number): number {
    switch (size) {
        case IconSize.XSmall:
            return 12;
        case IconSize.Small:
            return 14;
        case IconSize.Medium:
            return 18;
        case IconSize.Large:
            return 20;
        case IconSize.XLarge:
            return 24;
        default:
            return size;
    }
}
